import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=cbfad502&"
import script from "./IconArrow.vue?vue&type=script&lang=js&"
export * from "./IconArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports